export const SOCIAL_FIELDS = [
  "instagram_url",
  "facebook_url",
  "linkedin_url",
  "youtube_url",
  "tiktok_url",
] as const;
export type SocialField = (typeof SOCIAL_FIELDS)[number];
export const SOCIAL_LABELS: Record<SocialField, string> = {
  instagram_url: "Instagram",
  facebook_url: "Facebook",
  linkedin_url: "LinkedIn",
  youtube_url: "YouTube",
  tiktok_url: "TikTok",
};
export function normalizeSocialUrl(value: unknown): string | null {
  if (value == null || String(value).trim() === "") return null;
  const text = String(value).trim();
  if (text.length > 2048) throw new Error("Link troppo lungo");
  const url = new URL(
    /^[a-z][a-z0-9+.-]*:/i.test(text) ? text : `https://${text}`,
  );
  if (
    !["http:", "https:"].includes(url.protocol) ||
    url.username ||
    url.password ||
    !url.hostname.includes(".")
  )
    throw new Error("Inserisci un link HTTP o HTTPS valido");
  return url.href;
}
export function socialPayload(values: Partial<Record<SocialField, unknown>>) {
  return Object.fromEntries(
    SOCIAL_FIELDS.filter((key) => values[key] !== undefined).map((key) => [
      key,
      normalizeSocialUrl(values[key]),
    ]),
  );
}
